module.exports = __webpack_public_path__ + "img/destination-3.88579cc9.svg";